import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "@velaro/velaro-component-lib";
import useApi from "@/hooks/useApi";
import React, { useState } from "react";
import LoadingSpinner from "@/components/LoadingSpinner";
import SkillForm, { SkillModel, defaultSkillModel } from "./SkillForm";
import { SkillListItem } from "@/providers/SkillsProvider";
import {
  SecondaryBlueButton,
  PrimaryBlueButton
} from "@velaro/velaro-component-lib";

interface Props {
  show: boolean;
  onClose(): void;
  onSkillCreated(Skill: SkillListItem): void;
}

export default function CreateSkillModal(props: Props) {
  const api = useApi();
  const [skill, setSkill] = React.useState<SkillModel>(defaultSkillModel);
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState<boolean | undefined>(undefined);
  const [error, setError] = useState<string | undefined>(undefined);

  async function handleSubmit() {
    setSending(true);
    const response = await api.messaging.post("Skills", skill);
    const newSkill = await response.json();
    setSuccess(response.ok);
    if (response.ok) {
      props.onSkillCreated(newSkill);
    }
    if (!response.ok) {
      if (response.status === 400) {
        setError("This skill already exists.");
      } else {
        setError(
          "There was an error saving your changes. Please see Integration Log for more details."
        );
      }
    }
    setSending(false);
  }

  return (
    <Modal show={props.show} maxWidth="max-w-4xl">
      <div className="px-4">
        <ModalHeader title="New Skill" onClose={() => props.onClose()} />
      </div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <ModalBody>
          <div className="px-4">
            <SkillForm
              skill={skill}
              onChange={(updates) => {
                setSkill((oldState) => ({ ...oldState, ...updates }));
              }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="p-4 flex flex-col">
            {success === false && (
              <div className="flex flex-row mb-4">{error}</div>
            )}
            {sending ? (
              <div className="ml-auto flex">
                Saving Changes...
                <LoadingSpinner />
              </div>
            ) : (
              <div className="ml-auto flex flex-row">
                <div className="mr-2">
                  <SecondaryBlueButton label="Cancel" onClick={props.onClose} />
                </div>
                <PrimaryBlueButton
                  onClick={() => handleSubmit()}
                  label="Save Changes"
                />
              </div>
            )}
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
}
